import { CellSelectionOptions, FillOperationParams } from 'ag-grid-enterprise';
import { useMemo } from 'react';
import { RowData } from 'state/workspaces/secondary-market/batch/model';

export function useFillHandle() {
  return useMemo(() => {
    return {
      handle: {
        mode: 'fill',
        direction: 'y',
        setFillValue: (params: FillOperationParams<RowData>) => {
          return params.values[params.currentIndex];
        },
      },
    } satisfies CellSelectionOptions<RowData>;
  }, []);
}
